import React, { useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";

import "./OwnCar.scss";
import Progress from "../../../components/Progress/Progress";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";

import { StepPreFooter } from "../../../components/Footer/StepPreFooter";
import { useLocation } from "react-router-dom";
import { getPrevStepLink } from "../../../utils/functions";

import step3Icon from "../../../assets/images/step-icon/step17-icon.png";

import checkedIcon from "../../../assets/images/checked.png";

import { useForm } from "react-hook-form";
import { updateContact } from "../../../redux/apiCalls";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { StepBtn } from "../../../components/Button/StepBtn/StepBtn";
import { nextStepDelayTime } from "../../../utils/const";

const OwnCar = () => {
  const options = [
    { label: "Yes", value: "YES" },
    { label: "No", value: "NO" }
  ];
  const [loadingButton, setLoadingButton] = useState(false);
  const windowWidth = window.innerWidth;
  const isMobile = windowWidth < 768;

  const contactRedux = useSelector((state) => state?.contact?.contact);
  const [ownCar, setOwnCar] = useState(
    contactRedux?.own_car ?? ""
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentLoc = useLocation();
  const prevLink = getPrevStepLink(currentLoc.pathname);

  // custom
  const {
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm();
  const onSubmit = async () => {
    if (!ownCar) {
      setError("ownCar", {
        type: "invalid",
        message: "Please select one option."
      });
      return;
    }
    
    setLoadingButton(!loadingButton);

    if (!ownCar) {
      setError("ownCar", {
        type: "invalid",
        message: "Please select one option."
      });
      return;
    }

    const lead_id = sessionStorage.getItem("lead_id");
    const res = await updateContact(dispatch, contactRedux?._id, {
      step: 23,
      lead_id,
      own_car: ownCar
    });

    if (res?.status === 200) {
      setTimeout(() => {
        setLoadingButton(false);
        navigate("/creditscore");
      }, nextStepDelayTime);
    }
  };

  return (
    <Box className="step-17">
      <Navbar />
      <ScrollToTop />
      <Box
        sx={{
          width: "100%",
          maxWidth: "700px",
          margin: "20px auto"
        }}
      >
        <Box
          sx={{
            width: "100%",

            margin: "10px auto 30px",
            padding: isMobile && "0 15px"
          }}
        >
          <Progress step={22} />
        </Box>
        <div className="step-main">
          <form className="step-form" onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ textAlign: "center", marginBottom: "11px" }}>
              <img
                style={{
                  maxWidth: isMobile && "42px"
                }}
                src={step3Icon}
                alt=""
              />
            </Box>
            <h2 className="title">Do you own a car?</h2>

            <div className="form-control">
              <div className="list-btn-radio">
                {options.map((option, index) => (
                  <button
                    key={index}
                    className={`btn-radio ${
                      ownCar === option.value ? "active" : ""
                    }`}
                    onClick={() => {
                      setOwnCar(option.value)
                      clearErrors("ownCar");
                    }}
                    
                  >
                    {option.label}
                    {ownCar === option.value && (
                      <img className="checked-icon" src={checkedIcon} alt="" />
                    )}
                  </button>
                ))}
              </div>

              {errors?.ownCar && (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                    display: "block",
                    textAlign: "center"
                  }}
                  className="error"
                >
                  {errors.ownCar.message}
                </span>
              )}
            </div>

            <Box
              sx={{
                maxWidth: "474px",
                margin: "0 auto"
              }}
            >
              <StepBtn
                prevLink={prevLink}
                onSubmit={handleSubmit(onSubmit)}
                loading={loadingButton}
              />
            </Box>
          </form>
          <StepPreFooter />
        </div>
      </Box>

      {/* <Footer desc={false} /> */}
    </Box>
  );
};

export default OwnCar;
